import { useMapContext } from '../../map/MapContext';

/** Shown instead of the normal cluster zoom-in when a click hits 2+ features
 * stacked at the exact same coordinate (e.g. several monthly meter readings
 * recorded at one physical meter) — no amount of zooming can ever pull those
 * apart, so this gives the user an explicit list to pick one from. Positioned
 * at the click pixel inside the map's own relatively-positioned container, so
 * it must be rendered as a sibling of <MapCanvas />. */
export function OverlapPickerMenu() {
  const { overlapPicker, selectOverlapItem, closeOverlapPicker } = useMapContext();

  if (!overlapPicker) return null;
  const { pixel, items } = overlapPicker;

  // Anchoring at the raw click pixel works fine near the center of a desktop
  // map, but a tap near a phone's edge (very common — screens are small) would
  // push this w-56/max-h-64 box half off-screen. Clamp so it always stays
  // fully on screen instead.
  const left = Math.min(pixel[0], Math.max(8, window.innerWidth - 224 - 8));
  const top = Math.min(pixel[1], Math.max(8, window.innerHeight - 256 - 8));

  return (
    <>
      <div className="absolute inset-0 z-20" onClick={closeOverlapPicker} />
      <div
        className="absolute z-30 flex max-h-64 w-56 flex-col gap-0.5 overflow-y-auto rounded-xl border border-border-default bg-bg-surface p-1.5 shadow-lg"
        style={{ left, top }}
      >
        <p className="px-2 py-1 text-[11px] font-medium text-text-secondary">
          {items.length} объекта в одной точке — выберите:
        </p>
        {items.map((item) => (
          <button
            key={item.key}
            type="button"
            onClick={() => selectOverlapItem(item)}
            className="flex flex-col items-start rounded-lg px-2 py-1.5 text-left hover:bg-bg-surface-secondary"
          >
            <span className="w-full truncate text-[13px] text-text-primary">{item.title}</span>
            {item.layerName && <span className="w-full truncate text-[11px] text-text-secondary">{item.layerName}</span>}
          </button>
        ))}
      </div>
    </>
  );
}
